import { render, staticRenderFns } from "./BsnPlan2MemberList.vue?vue&type=template&id=ccaabc6a&"
import script from "./BsnPlan2MemberList.vue?vue&type=script&lang=js&"
export * from "./BsnPlan2MemberList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports